import { ThemeInterface } from "@styles/theme";

export const styles = (theme: ThemeInterface) => ({
	dateRangeContainer: {
		margin: "3px 0px 3px 15px",
	},
	root: {
		"& .MuiOutlinedInput-root": {
			width: "100%",
		},
		"& .MuiOutlinedInput-input": {
			fontSize: "14px",
			padding: "10.5px 14px",
		},
	},
	custom: {
		".MuiIconButton-root": {
			filled: {
				backgroundColor: theme.palette.primary.main,
			},
		},
		zIndex: 1,
		width: "max-content",
	},
});

export default styles;
